module.exports = __webpack_public_path__ + "media/common/images/GasNet_logo_white-cf89340a408d6359a09a62b22d408098.png";